import { Col, Row } from "antd";
import { tipoSitucoesProcessoJudical } from "constants/EnumTipoSituacaoProcessoJudicial";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import InputSearch from "shared/components/input/InputSearch";
import CustomSelect from "shared/components/select/CustomSelect";
import SelectCondominios from "shared/components/select/selectCondominios/SelectCondominios";

const FiltrosProcessosJudiciais = () => {
  const { setCondominioId, setUnidadeSacadoQuery, setTipoSituacaoProcessoJudicial } = useProcessosJudiciaisContext();

  return (
    <Row className="mt-4 mb-4">
      <Col xs={10} className="me-5">
        <InputSearch
          id="buscar-unidade-sacado"
          label="Pesquisar"
          placeholder="Buscar por unidade / sacado / número do processo"
          onSearchChange={setUnidadeSacadoQuery}
        />
      </Col>
      <Col xs={5} className="me-5">
        <SelectCondominios label="Condomínio" isClearable onChange={(opcao) => setCondominioId(opcao?.value)} />
      </Col>

      <Col xs={5}>
        <CustomSelect
          id="select-filtrar-situacao"
          label="Situação"
          isClearable
          usarValidacaoParaFormulario={false}
          options={tipoSitucoesProcessoJudical}
          onChange={(opcao) => setTipoSituacaoProcessoJudicial(opcao?.value)}
        />
      </Col>
    </Row>
  );
};

export default FiltrosProcessosJudiciais;
